import { getClassFromCard } from "../models/card";
import React, { useRef, useCallback } from "react";
import "./card.css";
import { debounce } from "debounce";
import { forceUpdate, setCardPreview } from "..";
import { miscState } from "../state";
import { AudioControl } from "../audio";
import { Golem } from "../cards/upgrades/golem";
export const cardWidth = 320;
export const cardHeight = 458;
const renderCardContents = (card) => {
    const cardType = getClassFromCard(card);
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { src: cardType.artUrl, width: cardWidth, height: cardHeight }),
        React.createElement("span", { className: "title" }, cardType.displayName),
        React.createElement("div", { className: "text" },
            cardType.requirements && (React.createElement("p", { className: "requirements" },
                React.createElement("b", null, "Requirement"),
                ": ",
                React.createElement("span", { className: "requirementDescription" }, cardType.requirements.description))),
            cardType.effect && cardType.effect.description !== "" && (React.createElement("p", { className: "effect" },
                React.createElement("b", null, "Effect"),
                ": ",
                cardType.effect.description)))));
};
export const renderCardPreviewAtLocation = (card, x, y) => {
    let className = "card preview";
    if (card.waitingForFeedback) {
        className += " waitingForFeedback";
    }
    if (card.wasPlayed) {
        className += " wasPlayed";
    }
    return (React.createElement("div", { className: className, style: { left: `${x}rem`, top: `${y}rem` } }, renderCardContents(card)));
};
export const CardComponent = (props) => {
    const { card, flip, deck, transformOverride, transformOffset, disableDrag, style } = props;
    const targetHoverPosition = useRef({ x: 0, y: 0 });
    const cardContainerRef = useRef(null);
    const onMouseEnter = () => {
        if (cardContainerRef.current &&
            !card.destroying &&
            !flip &&
            !(miscState.draggedCard && cardContainerRef.current === miscState.draggedCard.div)) {
            const rect = cardContainerRef.current.getBoundingClientRect();
            targetHoverPosition.current = { x: rect.right + 8, y: rect.top + rect.height / 2 - cardHeight / 2 };
            if (targetHoverPosition.current.y < 0) {
                targetHoverPosition.current.y = 0;
            }
            if (targetHoverPosition.current.x < 0) {
                targetHoverPosition.current.x = 0;
            }
            if (targetHoverPosition.current.x + cardWidth > window.innerWidth) {
                targetHoverPosition.current.x = rect.left - cardWidth - 12;
            }
            if (targetHoverPosition.current.y + cardHeight > window.innerHeight) {
                targetHoverPosition.current.y = window.innerHeight - cardHeight - 12;
            }
            setCardPreview(renderCardPreviewAtLocation(card, targetHoverPosition.current.x, targetHoverPosition.current.y), card.id);
        }
        onMouseLeave.clear();
    };
    const onMouseLeave = useCallback(debounce(() => {
        setCardPreview(null, card.id);
    }, 200), []);
    const onMouseDown = (e) => {
        e.preventDefault();
        if (!disableDrag && !card.waitingForFeedback && !document.getElementById("ui").contains(cardContainerRef.current)) {
            miscState.draggedCard = card;
            card.div.classList.add("dragging");
            miscState.dragStartPos = { ...card.position };
            AudioControl.draw.play();
            if (card instanceof Golem) {
                clearInterval(card.interval);
            }
            setCardPreview(null, card.id);
        }
    };
    const onClick = () => {
        if (card.waitingForFeedback && !card.destroying) {
            card.play();
        }
    };
    const containerStyle = {
        left: `${card.position.x}rem`,
        top: `${card.position.y}rem`,
        ...style,
    };
    if (cardContainerRef.current) {
        card.div = cardContainerRef.current;
    }
    let className = "card small";
    if (flip) {
        className += " flip";
        containerStyle.left = ""; // during flip anim we are inside the deck so our position should be 0 0
        containerStyle.top = "";
    }
    if (card.waitingForFeedback) {
        className += " waitingForFeedback";
    }
    if (card.wasPlayed) {
        className += " wasPlayed";
    }
    const destroyingTimer = useRef();
    if (card.destroying) {
        className += " destroying";
        if (!destroyingTimer.current) {
            setCardPreview(null, card.id);
            destroyingTimer.current = setTimeout(() => {
                if (deck) {
                    deck.discard.splice(deck.discard.indexOf(card));
                    forceUpdate();
                }
                else {
                    card.remove();
                }
            }, 500);
        }
    }
    if (transformOverride) {
        containerStyle.transform = transformOverride;
    }
    if (transformOffset) {
        // @ts-ignore
        containerStyle["--animationXOffset"] = transformOffset.x;
        // @ts-ignore
        containerStyle["--animationYOffset"] = transformOffset.y;
    }
    if (deck) {
        containerStyle.left = ""; // let discard handle our position
        containerStyle.top = "";
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: cardContainerRef, className: className, style: containerStyle, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, onClick: onClick }, renderCardContents(card))));
};
